/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC, useEffect, useMemo} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import { useLangList, useI18N} from '../../../i18n/Metronici18n'
import { changeLanguage } from '../../../../app/common/utils/request'
import { useIntl } from 'react-intl'
import {useSelector} from "react-redux";

export const languages = [
  {
    lang: 'en',
    name: 'English',
    flag: toAbsoluteUrl('/media/flags/united-states.svg'),
  },
  {
    lang: 'zh',
    name: 'Mandarin',
    flag: toAbsoluteUrl('/media/flags/china.svg'),
  },
  {
    lang: 'es',
    name: 'Spanish',
    flag: toAbsoluteUrl('/media/flags/spain.svg'),
  },
  {
    lang: 'ja',
    name: 'Japanese',
    flag: toAbsoluteUrl('/media/flags/japan.svg'),
  },
  {
    lang: 'de',
    name: 'German',
    flag: toAbsoluteUrl('/media/flags/germany.svg'),
  },
  {
    lang: 'fr',
    name: 'Français',
    flag: toAbsoluteUrl('/media/flags/france.svg'),
  },
]

const Languages: FC = () => {
  const intl = useIntl()
  const  langList = useLangList()
  const {updateLangState, selectedLang} = useI18N()
  const currentLangue = useMemo(( ) => {
    return languages.find((l:any) => l.lang === selectedLang)
  },[selectedLang])

  const profileData = useSelector((state:any) => state?.userProfileData)
  useEffect(() => {
       if (profileData?.Lang && profileData?.Lang !=='') {
         updateLangState(profileData?.Lang?.toLocaleLowerCase())
       }
  }, [profileData]);
  return (
    <div
       className='menu-item px-5 '
       data-kt-menu-trigger='hover'
       data-kt-menu-placement='left-start'
       data-kt-menu-flip='bottom'
    >
      <a href='#'  className='menu-link px-5'>
        <span className='menu-title position-relative'>
          {intl.formatMessage({id: 'LANGUAGE'})}
          <span className='fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0'>
            {//currentLanguage?.name
              currentLangue?.name
            }{' '}
            <img
              className='w-15px h-15px rounded-1 ms-2'
              src={
                currentLangue?.flag
                //currentLanguage?.flag
              }
              alt='metronic'
            />
          </span>
        </span>
      </a>

      <div className='menu-sub menu-sub-dropdown py-4 '>
        {langList.map((l) => (
          <div

            className='menu-item px-0 px-md-3'
            key={l.lang}
            onClick={async () => {
              await changeLanguage(l.lang)
              updateLangState(l.lang?.toLocaleLowerCase())
            }}
          >
            <a
              href='#'
              className={clsx('menu-link d-flex gap-1 gap-md-3', {active: l.lang === currentLangue?.lang})}
            >
              <span className='symbol symbol-20px'>
                <img className='rounded-1' src={l.flag} alt='metronic' />
              </span>
              <span>{l?.name}</span>
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export {Languages}
